import { render, staticRenderFns } from "./DataCenter.vue?vue&type=template&id=2d6f13d1&scoped=true&"
import script from "./DataCenter.vue?vue&type=script&lang=js&"
export * from "./DataCenter.vue?vue&type=script&lang=js&"
import style0 from "./DataCenter.vue?vue&type=style&index=0&id=2d6f13d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f13d1",
  null
  
)

export default component.exports